export default "__VITE_ASSET__Bjz2aa2T__"